import { LinkButton } from "components/buttons";
import { Breadcrumbs, HorizontalLinkGroup } from "components/navigation";
import { UserAccess } from "components/user-access";
import { PageRestricted } from "pages/errors/page-restricted";
import { PcnAdminOnHoldListing, PcnAdminClosedListing, PcnAdminOpenListing } from "pages/pcn/admin/listing";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";


export function PcnAdminListing({ breadcrumbs }) {

    const dispatch = useDispatch();

    const routes = [
        { location: "/pcn-admin/open", title: "Open PCNs" },
        { location: "/pcn-admin/closed", title: "Closed PCNs" },
        { location: "/pcn-admin/on-hold", title: "Holding Area" },
        { location: `${window.env.PCN_URL}/invoiceSearch`, title: "Pending Invoices", externalLink: true },
        { location: `${window.env.PCN_URL}/processedInvoice`, title: "Processed Invoices", externalLink: true },
    ];

    useEffect(() => {
        dispatch({ type: 'SITE_FULL_WIDTH' });
    }, []);

    return (
        <UserAccess
            perform="Internal"
            yes={() => (
                <div className="row spacer-top">
                    <Breadcrumbs items={breadcrumbs} />
                    <h1>Penalty Charge Notices - Admin</h1>

                    <div className="button-row button-row-stacked-mobile spacer-bottom">
                        <div className="inline-items">
                            <LinkButton
                                text="Add new PCN"
                                intent="primary"
                                href={`${window.env.PCN_URL}/newpcn`}
                                externalLink
                            />
                            <LinkButton
                                text="Settings"
                                intent="primary"
                                href="/pcn-admin/settings"
                            />
                        </div>
                    </div>

                    <div className="spacer-bottom">
                        <HorizontalLinkGroup
                            links={routes}
                            exactRouteMatch={true}
                        ></HorizontalLinkGroup>
                    </div>

                    <Routes>
                        <Route path="open" element={<PcnAdminOpenListing />} />
                        <Route path="closed" element={<PcnAdminClosedListing />} />
                        <Route path="on-hold" element={<PcnAdminOnHoldListing />} />
                        <Route path="" element={<Navigate to="/pcn-admin/open" replace />} />
                    </Routes>
                </div>
            )}
            no={() => <PageRestricted />}
        />
    );

}